import { SwUpdate } from '@angular/service-worker'
import { interval } from 'rxjs'
import { Injectable } from '@angular/core'
import { ToastrService } from 'ngx-toastr'

@Injectable({ providedIn: 'root' })
export class UpdateService {
  constructor(
    public updates: SwUpdate,
    private toastr: ToastrService
  ) {
    console.log(`updates enabled: ${updates.isEnabled}`)
    if (updates.isEnabled) {
      interval(5 * 60 * 1000).subscribe(() => updates.checkForUpdate())

      updates.versionUpdates.subscribe(event => {
        console.log({ event })
      })
    }
  }

  public checkForUpdates(): void {
    if (this.updates.isEnabled) {
      this.updates.checkForUpdate().then(res => res && this.promptUser())
    }
  }

  private promptUser(): void {
    console.log('updating to new version')
    this.updates
      .activateUpdate()
      .then(() =>
        this.toastr.info(
          'A new version of the application is available. Please save your work and reload the page.',
          'Update Found',
          { disableTimeOut: true }
        )
      )
  }
}
